var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "98d12ffd4183a5e8c3b1e1e64ab38b2a6d2a0783"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["butternutbox-frontend@butternut"] = {
  id: "98d12ffd4183a5e8c3b1e1e64ab38b2a6d2a0783"
};